(() => {

  const initHeader = (header) => {

    if (!header || header.dataset.bfHeaderReady === 'true') {
      return;
    }

    header.dataset.bfHeaderReady = 'true';


    const shopToggle =
      header.querySelector(
        '[data-bf-shop-toggle]'
      );


    const shopPanel =
      header.querySelector(
        '[data-bf-shop-panel]'
      );


    const menuToggles =
      header.querySelectorAll(
        '[data-bf-menu-toggle]'
      );


    const menu =
      header.querySelector(
        '[data-bf-menu]'
      );


    const menuClose =
      header.querySelector(
        '[data-bf-menu-close]'
      );


    /* =====================================================
       SCROLL STATE
    ===================================================== */

    const updateScrollState = () => {

      header.classList.toggle(
        'is-scrolled',
        window.scrollY > 24
      );

    };


    updateScrollState();


    window.addEventListener(
      'scroll',
      updateScrollState,
      {
        passive: true
      }
    );


    /* =====================================================
       SHOP PANEL
    ===================================================== */

    const closeShop = () => {

      if (!shopPanel) return;


      shopPanel.classList.remove(
        'is-open'
      );


      shopPanel.setAttribute(
        'aria-hidden',
        'true'
      );


      if (shopToggle) {

        shopToggle.setAttribute(
          'aria-expanded',
          'false'
        );

      }


      header.classList.remove(
        'is-panel-open'
      );

    };


    const openShop = () => {

      if (!shopPanel) return;


      shopPanel.classList.add(
        'is-open'
      );


      shopPanel.setAttribute(
        'aria-hidden',
        'false'
      );


      if (shopToggle) {

        shopToggle.setAttribute(
          'aria-expanded',
          'true'
        );

      }


      header.classList.add(
        'is-panel-open'
      );

    };


    const toggleShop = () => {

      if (!shopPanel) return;


      const open =
        shopPanel.classList.contains(
          'is-open'
        );


      if (open) {
        closeShop();
      } else {
        closeShop();
        openShop();
      }

    };


    if (shopToggle) {

      shopToggle.addEventListener(
        'click',
        (event) => {

          event.stopPropagation();

          toggleShop();

        }
      );

    }


    /* =====================================================
       FULLSCREEN MENU
    ===================================================== */

    const closeMenu = () => {

      if (!menu) return;


      menu.classList.remove(
        'is-open'
      );


      menu.setAttribute(
        'aria-hidden',
        'true'
      );


      menuToggles.forEach(
        (toggle) => {

          toggle.setAttribute(
            'aria-expanded',
            'false'
          );

        }
      );


      document.body.classList.remove(
        'bf-menu-open'
      );

    };


    const openMenu = () => {

      if (!menu) return;


      closeShop();


      menu.classList.add(
        'is-open'
      );


      menu.setAttribute(
        'aria-hidden',
        'false'
      );


      menuToggles.forEach(
        (toggle) => {

          toggle.setAttribute(
            'aria-expanded',
            'true'
          );

        }
      );


      document.body.classList.add(
        'bf-menu-open'
      );

    };


    const toggleMenu = () => {

      if (!menu) return;


      const open =
        menu.classList.contains(
          'is-open'
        );


      if (open) {
        closeMenu();
      } else {
        openMenu();
      }

    };


    menuToggles.forEach(
      (toggle) => {

        toggle.addEventListener(
          'click',
          (event) => {

            event.stopPropagation();

            toggleMenu();

          }
        );

      }
    );


    if (menuClose) {

      menuClose.addEventListener(
        'click',
        closeMenu
      );

    }


    const menuBackdrop =
      menu?.querySelector(
        '.bf-menu__backdrop'
      );


    if (menuBackdrop) {

      menuBackdrop.addEventListener(
        'click',
        closeMenu
      );

    }


    /* =====================================================
       GLOBAL CLOSE EVENTS
    ===================================================== */

    document.addEventListener(
      'click',
      (event) => {

        if (
          shopPanel &&
          shopPanel.classList.contains(
            'is-open'
          ) &&
          !shopPanel.contains(
            event.target
          ) &&
          !shopToggle?.contains(
            event.target
          )
        ) {

          closeShop();

        }

      }
    );


    document.addEventListener(
      'keydown',
      (event) => {

        if (event.key !== 'Escape') {
          return;
        }


        closeShop();
        closeMenu();

      }
    );


    /* =====================================================
       SHOPIFY EDITOR CLEANUP
    ===================================================== */

    header._bfHeaderCleanup = () => {

      window.removeEventListener(
        'scroll',
        updateScrollState
      );


      document.body.classList.remove(
        'bf-menu-open'
      );

    };

  };


  const initAllHeaders = (
    root = document
  ) => {

    root
      .querySelectorAll(
        '[data-bf-header]'
      )
      .forEach(
        initHeader
      );

  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initAllHeaders();

      }
    );

  } else {

    initAllHeaders();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initAllHeaders(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {

      const header =
        event.target.querySelector(
          '[data-bf-header]'
        );


      if (
        header &&
        typeof header._bfHeaderCleanup ===
          'function'
      ) {

        header._bfHeaderCleanup();

      }

    }
  );

})();